import { render, staticRenderFns } from "./action-notifications.vue?vue&type=template&id=a28fbcce&"
import script from "./action-notifications.ts?vue&type=script&lang=js&"
export * from "./action-notifications.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports